var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row scorecard-list-item pt-1 pb-1 mb-2",
      style: { background: _vm.index % 2 === 1 ? "#f3f5f7" : "#fff" },
    },
    [
      _c("div", { staticClass: "col-2" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.scorecard.plantName) +
              " / " +
              _vm._s(_vm.scorecard.unitName)
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-2" }, [
        _vm.scorecard.outageManager
          ? _c("span", [_vm._v(_vm._s(_vm.scorecard.outageManager))])
          : _vm._e(),
        !_vm.scorecard.outageManager ? _c("span", [_vm._v("N/A")]) : _vm._e(),
      ]),
      _c("div", { staticClass: "col-2" }, [
        _c("span", [_vm._v(_vm._s(_vm.scorecard.outageId))]),
      ]),
      _c("div", { staticClass: "col-1" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.getPhaseTitle(_vm.scorecard.currentPhase))),
        ]),
      ]),
      _c("div", { staticClass: "col-2" }, [
        _c(
          "span",
          [
            _c("font-awesome-icon", { attrs: { icon: "calendar-alt" } }),
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("dateFormat")(
                    new Date(_vm.scorecard.startDate),
                    "YYYY-MM-DD HH:mm"
                  )
                ) +
                " "
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-1" }, [
        _c(
          "span",
          [
            _c("font-awesome-icon", { attrs: { icon: "clock" } }),
            _vm._v(" " + _vm._s(_vm.scorecard.duration) + " "),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-1" }, [
        _c(
          "span",
          [
            _c("font-awesome-icon", { attrs: { icon: "stopwatch" } }),
            _vm._v(" " + _vm._s(_vm.scorecard.daysToGo) + " "),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-1" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.scorecard.totalScore.toFixed(0)) + " %"),
        ]),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-primary float-right",
            attrs: {
              type: "button",
              "data-toggle": "modal",
              "data-target": "#scorecardModal",
            },
            on: {
              click: function ($event) {
                return _vm.showDetails()
              },
            },
          },
          [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }